import { useState, useEffect, useRef } from "react";
import "./DirectoryResultsFilters.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import { US_STATES } from "../../../../utils/usStates";
import api from "@api";
import { YOUTH_BUCKETS, ADULT_BUCKETS } from "../../../../utils/ageBuckets";
import { getProgramTypeLabel } from "../../../../utils/programTypes";
function DirectoryResultsFilters({
  allSports,
  allAudiences,
  allAges,
  allPrograms,
  availableStates = [],
  count,
  viewMode,
  setViewMode,
  county,
  stateName,
  stateCode,
  page,
  totalPages,
  setPage,
}) {
  const filtersRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [sportsOpen, setSportsOpen] = useState(false);
  const [audienceOpen, setAudienceOpen] = useState(false);
  const [ageOpen, setAgeOpen] = useState(false);
  const [programOpen, setProgramOpen] = useState(false);
  // const sportsOpen = searchParams.get("sportsOpen") === "true";
  const [stateOpen, setStateOpen] = useState(false);
  const [countyOpen, setCountyOpen] = useState(false);
  const [counties, setCounties] = useState([]);
  const locationDropdownRef = useRef(null);
  const pathSport =
    location.pathname.startsWith("/state/") &&
      location.pathname.split("/")[3] === "county" &&
      location.pathname.split("/")[5] === "sport"
      ? location.pathname.split("/")[6] || ""
      : location.pathname.startsWith("/state/") &&
        location.pathname.split("/")[3] === "sport"
        ? location.pathname.split("/")[4] || ""
        : location.pathname.startsWith("/county/") &&
          location.pathname.split("/")[3] === "sport"
          ? location.pathname.split("/")[4] || ""
          : location.pathname.startsWith("/sport/") &&
            location.pathname.split("/")[2] !== "audience"
            ? location.pathname.split("/")[2] || ""
            : "";

  const pathAudience =
    location.pathname.startsWith("/state/") &&
      location.pathname.split("/")[3] === "county" &&
      location.pathname.split("/")[5] === "sport" &&
      location.pathname.split("/")[7] === "audience"
      ? location.pathname.split("/")[8] || ""
      : location.pathname.startsWith("/state/") &&
        location.pathname.split("/")[3] === "sport" &&
        location.pathname.split("/")[5] === "audience"
        ? location.pathname.split("/")[6] || ""
        : location.pathname.startsWith("/state/") &&
          location.pathname.split("/")[3] === "county" &&
          location.pathname.split("/")[5] === "audience"
          ? location.pathname.split("/")[6] || ""
          : location.pathname.startsWith("/state/") &&
            location.pathname.split("/")[3] === "audience"
            ? location.pathname.split("/")[4] || ""
            : location.pathname.startsWith("/sport/") &&
              location.pathname.split("/")[3] === "audience"
              ? location.pathname.split("/")[4] || ""
              : location.pathname.startsWith("/audience/")
                ? location.pathname.split("/")[2] || ""
                : "";

  const selectedSports = pathSport
    ? [pathSport]
    : searchParams.getAll("sport");


  const selectedAudiences = pathAudience
    ? [pathAudience]
    : searchParams.getAll("gender");
  const selectedAges = searchParams.getAll("age");
  const selectedPrograms = searchParams.getAll("type");
  const availableAgeSet = new Set((allAges || []).map((a) => String(a)));
  const audienceBasePath =
    stateCode && county && selectedSports.length === 1
      ? `/state/${stateCode.toLowerCase()}/county/${county.toLowerCase().replace(/\s+/g, "-")}/sport/${selectedSports[0]}/audience`
      : stateCode && selectedSports.length === 1
        ? `/state/${stateCode.toLowerCase()}/sport/${selectedSports[0]}/audience`
        : stateCode && county
          ? `/state/${stateCode.toLowerCase()}/county/${county.toLowerCase().replace(/\s+/g, "-")}/audience`
          : stateCode
            ? `/state/${stateCode.toLowerCase()}/audience`
            : selectedSports.length === 1
              ? `/sport/${selectedSports[0]}/audience`
              : "/audience";



  const resetFilters = () => {
    setSportsOpen(false);
    setAudienceOpen(false);
    setAgeOpen(false);
    setProgramOpen(false);
    setStateOpen(false);
    setCountyOpen(false);

    navigate("/sport");
  };
  const getPreservedSearch = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("state");
    params.delete("county");
    params.delete("intent");
    return params.toString();
  };


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (locationDropdownRef.current?.contains(e.target)) return;
      setStateOpen(false);
      setCountyOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!stateCode) {
      setCounties([]);
      return;
    }

    api
      .get(`/api/directory/states/${stateCode.toUpperCase()}/counties`, {
        params: {
          sport: selectedSports,
          gender: selectedAudiences,
          type: selectedPrograms,
          age: selectedAges,
        },
      })
      .then((res) => setCounties(res.data || []))
      .catch(() => setCounties([]));
  }, [
    stateCode,
    selectedSports.join(","),
    selectedAudiences.join(","),
    selectedPrograms.join(","),
    selectedAges.join(","),
  ]);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!filtersRef.current) return;
      if (filtersRef.current.contains(e.target)) return;

      setSportsOpen(false);
      setAudienceOpen(false);
      setAgeOpen(false);
      setProgramOpen(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const isMobile = window.innerWidth <= 768;

  const selectState = (nextStateCode) => {
    const params = new URLSearchParams(searchParams);
    const preservedSearch = getPreservedSearch();
    const nextState = nextStateCode.toLowerCase();

    if (selectedSports.length === 1 && selectedAudiences.length === 1) {
      navigate({
        pathname: `/state/${nextState}/sport/${selectedSports[0]}/audience/${selectedAudiences[0]}`,
        search: preservedSearch,
      });
    } else if (selectedSports.length === 1) {
      navigate({
        pathname: `/state/${nextState}/sport/${selectedSports[0]}`,
        search: preservedSearch,
      });
    } else if (selectedAudiences.length === 1) {
      navigate({
        pathname: `/state/${nextState}/audience/${selectedAudiences[0]}`,
        search: preservedSearch,
      });
    } else {
      navigate({
        pathname: `/state/${nextState}/sport`,
        search: preservedSearch,
      });
    }

    setStateOpen(false);
    setCountyOpen(false);
  };




  const selectCounty = (countyName) => {
    if (!stateCode || !countyName?.trim()) return;

    const preservedSearch = getPreservedSearch();
    const countySlug = countyName.toLowerCase().replace(/\s+/g, "-");
    const nextState = stateCode.toLowerCase();

    if (selectedSports.length === 1 && selectedAudiences.length === 1) {
      navigate({
        pathname: `/state/${nextState}/county/${countySlug}/sport/${selectedSports[0]}/audience/${selectedAudiences[0]}`,
        search: preservedSearch,
      });
    } else if (selectedSports.length === 1) {
      navigate({
        pathname: `/state/${nextState}/county/${countySlug}/sport/${selectedSports[0]}`,
        search: preservedSearch,
      });
    } else if (selectedAudiences.length === 1) {
      navigate({
        pathname: `/state/${nextState}/county/${countySlug}/audience/${selectedAudiences[0]}`,
        search: preservedSearch,
      });
    } else {
      navigate({
        pathname: `/state/${nextState}/county/${countySlug}/sport`,
        search: preservedSearch,
      });
    }

    setCountyOpen(false);
    setStateOpen(false);
  };


  const getStateLabel = (code) => {
    if (!code) return "";
    const match = US_STATES.find(
      s => s.code.toLowerCase() === code.toLowerCase()
    );
    return match ? match.name : code.toUpperCase();
  };


  const isVerified = searchParams.get("verified") === "true";

  const toggleVerified = () => {
    const params = new URLSearchParams(searchParams);

    if (isVerified) {
      params.delete("verified");
    } else {
      params.set("verified", "true");
    }

    setSearchParams(params, { replace: true });
  };




  const toggleSport = (value) => {
    const existing = selectedSports;
    const next = existing.includes(value)
      ? existing.filter((v) => v !== value)
      : [...existing, value];

    const countySlug = county ? county.toLowerCase().replace(/\s+/g, "-") : "";
    const params = new URLSearchParams(searchParams);

    params.delete("sport");
    params.delete("intent");

    if (next.length === 0) {
      navigate(
        {
          pathname:
            selectedAudiences.length === 1
              ? stateCode && county
                ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/audience/${selectedAudiences[0]}`
                : stateCode
                  ? `/state/${stateCode.toLowerCase()}/audience/${selectedAudiences[0]}`
                  : `/audience/${selectedAudiences[0]}`
              : stateCode && county
                ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/sport`
                : stateCode
                  ? `/state/${stateCode.toLowerCase()}/sport`
                  : "/sport",
          search: params.toString(),
        },
        { replace: true }
      );
      return;
    }

    if (next.length === 1) {
      navigate(
        {
          pathname:
            selectedAudiences.length === 1
              ? stateCode && county
                ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/sport/${next[0]}/audience/${selectedAudiences[0]}`
                : stateCode
                  ? `/state/${stateCode.toLowerCase()}/sport/${next[0]}/audience/${selectedAudiences[0]}`
                  : `/sport/${next[0]}/audience/${selectedAudiences[0]}`
              : stateCode && county
                ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/sport/${next[0]}`
                : stateCode
                  ? `/state/${stateCode.toLowerCase()}/sport/${next[0]}`
                  : `/sport/${next[0]}`,
          search: params.toString(),
        },
        { replace: selectedSports.length > 0 }
      );
      return;
    }

    next.forEach((sport) => params.append("sport", sport));

    if (selectedAudiences.length === 1) {
      navigate(
        {
          pathname:
            stateCode && county
              ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/audience/${selectedAudiences[0]}`
              : stateCode
                ? `/state/${stateCode.toLowerCase()}/audience/${selectedAudiences[0]}`
                : `/audience/${selectedAudiences[0]}`,
          search: params.toString(),
        },
        { replace: true }
      );
      return;
    }

    navigate(
      {
        pathname:
          stateCode && county
            ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/sport`
            : stateCode
              ? `/state/${stateCode.toLowerCase()}/sport`
              : "/sport",
        search: params.toString(),
      },
      { replace: true }
    );
  };


  const toggleAudience = (value) => {
    const params = new URLSearchParams(searchParams);
    const existingAudiences = params.getAll("gender");
    const currentAudiences = pathAudience ? [pathAudience] : existingAudiences;

    let next = currentAudiences.includes(value)
      ? currentAudiences.filter((a) => a !== value)
      : [...currentAudiences, value];

    const nextAudiences = next.filter((v) =>
      allAudiences.map((a) => a.toLowerCase()).includes(v)
    );

    const countySlug = county ? county.toLowerCase().replace(/\s+/g, "-") : "";

    params.delete("gender");
    params.delete("intent");

    if (nextAudiences.length === 0) {
      navigate(
        {
          pathname:
            selectedSports.length === 1
              ? stateCode && county
                ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/sport/${selectedSports[0]}`
                : stateCode
                  ? `/state/${stateCode.toLowerCase()}/sport/${selectedSports[0]}`
                  : `/sport/${selectedSports[0]}`
              : stateCode && county
                ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/audience`
                : stateCode
                  ? `/state/${stateCode.toLowerCase()}/audience`
                  : audienceBasePath,
          search: params.toString(),
        },
        { replace: true }
      );
      return;
    }

    if (nextAudiences.length === 1) {
      navigate(
        {
          pathname:
            selectedSports.length === 1
              ? stateCode && county
                ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/sport/${selectedSports[0]}/audience/${nextAudiences[0]}`
                : stateCode
                  ? `/state/${stateCode.toLowerCase()}/sport/${selectedSports[0]}/audience/${nextAudiences[0]}`
                  : `/sport/${selectedSports[0]}/audience/${nextAudiences[0]}`
              : stateCode && county
                ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/audience/${nextAudiences[0]}`
                : stateCode
                  ? `/state/${stateCode.toLowerCase()}/audience/${nextAudiences[0]}`
                  : `${audienceBasePath}/${nextAudiences[0]}`,
          search: params.toString(),
        },
        { replace: true }
      );
      return;
    }

    nextAudiences.forEach((a) => params.append("gender", a));

    navigate(
      {
        pathname:
          selectedSports.length === 1
            ? stateCode && county
              ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/sport/${selectedSports[0]}`
              : stateCode
                ? `/state/${stateCode.toLowerCase()}/sport/${selectedSports[0]}`
                : `/sport/${selectedSports[0]}`
            : stateCode && county
              ? `/state/${stateCode.toLowerCase()}/county/${countySlug}/audience`
              : stateCode
                ? `/state/${stateCode.toLowerCase()}/audience`
                : audienceBasePath,
        search: params.toString(),
      },
      { replace: true }
    );
  };

  const toggleAge = (value) => {
    const params = new URLSearchParams(searchParams);
    let existing = params.getAll("age");

    const isYouthValue = youthValues.includes(value);
    const isAdultValue = adultValues.includes(value);

    // If selecting youth → remove adult
    if (isYouthValue) {
      existing = existing.filter(v => !adultValues.includes(v));
    }

    // If selecting adult → remove youth
    if (isAdultValue) {
      existing = existing.filter(v => !youthValues.includes(v));
    }

    if (existing.includes(value)) {
      existing = existing.filter(v => v !== value);
    } else {
      existing.push(value);
    }

    params.delete("age");
    existing.forEach(v => params.append("age", v));

    params.set("intent", "age");
    setSearchParams(params, { replace: true });
  };

  const toggleAgeGroup = (group) => {
    const params = new URLSearchParams(searchParams);

    params.delete("age");

    if (group === "youth") {
      youthValues.forEach(v => params.append("age", v));
    }

    if (group === "adult") {
      adultValues.forEach(v => params.append("age", v));
    }

    params.set("intent", "age");
    setSearchParams(params, { replace: true });
  };





  const toggleProgram = (value) => {
    const params = new URLSearchParams(searchParams);
    const existing = params.getAll("type");

    let next = existing.includes(value)
      ? existing.filter(v => v !== value)
      : [...existing, value];

    // 🔑 if ALL selected → collapse to "All"
    params.delete("type");
    next.forEach(v => params.append("type", v));

    params.set("intent", "type");
    setSearchParams(params, { replace: true });
  };


  const formatSlugLabel = (value = "") => {
    return value
      .replace("_plus", "+")      // age case
      .replace(/_/g, " ")         // flag_football → flag football
      .split(" ")
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  };



  const toTitleCase = (str = "") =>
    str
      .split(" ")
      .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(" ");

  const leagueLabel = count === 1 ? "league" : "leagues";


  const sportsLabel =
    isMobile
      ? ""
      : selectedSports.length === 0
        ? "All"
        : selectedSports.length === 1
          ? toTitleCase(selectedSports[0])
          : `${selectedSports.length}+`;


  const audienceLabel =
    isMobile
      ? ""
      : selectedAudiences.length === 0
        ? "All"
        : selectedAudiences.length === 1
          ? toTitleCase(selectedAudiences[0])
          : `${selectedAudiences.length}+`;


  const ageLabel =
    isMobile
      ? ""
      : selectedAges.length === 0
        ? "All"
        : selectedAges.length === 1
          ? formatSlugLabel(selectedAges[0])
          : `${selectedAges.length}+`;




  const programLabel =
    isMobile
      ? ""
      : selectedPrograms.length === 0
        ? "All"
        : selectedPrograms.length === 1
          ? toTitleCase(selectedPrograms[0])
          : `${selectedPrograms.length}+`;

  const stateLabel = stateCode ? getStateLabel(stateCode) : "All";
  const countyLabel = county ? toTitleCase(county) : "All";





  const hasActiveFilters =
    selectedSports.length > 0 ||
    selectedAudiences.length > 0 ||
    selectedAges.length > 0 ||
    selectedPrograms.length > 0 ||
    isVerified ||
    !!stateCode ||
    !!county;

  const hasSingleSport = selectedSports.length === 1;
  const hasSingleAudience = selectedAudiences.length === 1;
  const hasSingleProgram = selectedPrograms.length === 1;
  const hasSingleAge = selectedAges.length === 1;

  let summaryParts = [];

  const itemLabel = count === 1 ? "listing" : "listings";

  let displayText = "";
  if (!hasSingleAge) {
    if (hasSingleAudience) {
      summaryParts.push(formatSlugLabel(selectedAudiences[0]));
    }

    if (hasSingleSport) {
      summaryParts.push(toTitleCase(selectedSports[0]));
    }

    if (hasSingleProgram) {
      summaryParts.push(formatSlugLabel(selectedPrograms[0]));
    }
  }
  if (hasSingleAge) {
    const ageLabel = formatSlugLabel(selectedAges[0]);

    const otherParts = [];

    if (hasSingleAudience) {
      otherParts.push(formatSlugLabel(selectedAudiences[0]));
    }

    if (hasSingleSport) {
      otherParts.push(toTitleCase(selectedSports[0]));
    }

    if (hasSingleProgram) {
      otherParts.push(formatSlugLabel(selectedPrograms[0]));
    }

    displayText = `for ages ${ageLabel}${otherParts.length ? " " + otherParts.join(" ") : ""}`;
  } else if (summaryParts.length > 0) {
    displayText = summaryParts.join(" ");
  }




  const getYouthBucketValue = (bucket) => {
    if (bucket.value) return bucket.value;
    return `${bucket.min}-${bucket.max}`;
  };

  const getAdultBucketValue = (bucket) => {
    if (bucket.value) return bucket.value;
    return `${bucket.min}_plus`;
  };

  const visibleYouthBuckets = YOUTH_BUCKETS.filter((bucket) => {
    const value = getYouthBucketValue(bucket);
    return availableAgeSet.has(value);
  });

  const visibleAdultBuckets = ADULT_BUCKETS.filter((bucket) => {
    const value = getAdultBucketValue(bucket);
    return availableAgeSet.has(value);
  });

  const youthValues = visibleYouthBuckets.map(getYouthBucketValue);
  const adultValues = visibleAdultBuckets.map(getAdultBucketValue);

  const isYouthGroupSelected =
    youthValues.length > 0 &&
    youthValues.every(v => selectedAges.includes(v));

  const isAdultGroupSelected =
    adultValues.length > 0 &&
    adultValues.every(v => selectedAges.includes(v));

  return (

    <div className="directory-results-filters">



      <div className="results-filters-row" ref={filtersRef}>

        {/* RIGHT SIDE FILTER */}
        <div className="right-side-filters">
          <input
            className="directory-search"
            value={searchParams.get("q") || ""}
            onChange={(e) => {
              const params = new URLSearchParams(searchParams);
              const val = e.target.value;

              if (!val.trim()) params.delete("q");
              else params.set("q", val);

              setSearchParams(params, { replace: true });
            }}
            placeholder="Search by name..."
          />
          <div
            className={`result-filter-chip verified-filter-chip ${isVerified ? "active" : ""}`}
            onClick={toggleVerified}
          >
            ⭐ Verified
          </div>


          {/* SPORTS DROPDOWN */}
          <div className="results-sport-dropdown">
            <div
              className={`result-filter-chip dropdown-trigger ${selectedSports.length > 0 ? "active" : ""}`}
              onClick={() => {
                setAudienceOpen(false);
                setAgeOpen(false);
                setProgramOpen(false);
                setSportsOpen((prev) => !prev);
              }}
            >
              <span className="filter-chip-text-wrap">
                <span className="filter-chip-label">Sport</span>
                <span className="filter-chip-value-row">
                  <span className="filter-chip-value">
                    {selectedSports.length === 0
                      ? "All"
                      : selectedSports.length === 1
                        ? formatSlugLabel(selectedSports[0])
                        : `${formatSlugLabel(selectedSports[0])} +${selectedSports.length - 1}`}
                  </span>
                </span>
              </span>

              <span className="filter-caret" data-open={sportsOpen}>
                ▾
              </span>
            </div>

            {sportsOpen && (
              <div className="results-sport-filters">
                <label className="sport-checkbox all">
                  <input
                    type="checkbox"
                    checked={selectedSports.length === 0}
                    onChange={() => {
                      if (selectedSports.length === 0) return;

                      const params = new URLSearchParams(searchParams);
                      params.delete("sport");
                      params.delete("intent");

                      navigate(
                        {
                          pathname: stateCode && county
                            ? `/state/${stateCode.toLowerCase()}/county/${county.toLowerCase().replace(/\s+/g, "-")}/sport`
                            : stateCode
                              ? `/state/${stateCode.toLowerCase()}/sport`
                              : selectedAudiences.length === 1
                                ? `/audience/${selectedAudiences[0]}`
                                : "/sport",
                          search: params.toString(),
                        },
                        { replace: true }
                      );
                    }}
                  />
                  All
                </label>
                {allSports.map((s) => {
                  const value = s.toLowerCase();
                  return (
                    <label key={value} className="sport-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedSports.includes(value)}
                        onChange={() => toggleSport(value)}
                      />
                      {formatSlugLabel(s)}
                    </label>
                  );
                })}
              </div>
            )}
          </div>



          {/* AUDIENCES DROPDOWN */}
          <div className="results-audience-dropdown">
            <div
              className={`result-filter-chip dropdown-trigger ${selectedAudiences.length > 0 ? "active" : ""}`}
              onClick={() => {
                setSportsOpen(false);
                setAgeOpen(false);
                setProgramOpen(false);
                setAudienceOpen((prev) => !prev);
              }}
            >
              <span className="filter-chip-text-wrap">
                <span className="filter-chip-label">Audience</span>
                <span className="filter-chip-value-row">
                  <span className="filter-chip-value">
                    {selectedAudiences.length === 0
                      ? "All"
                      : selectedAudiences.length === 1
                        ? formatSlugLabel(selectedAudiences[0])
                        : `${formatSlugLabel(selectedAudiences[0])} +${selectedAudiences.length - 1}`}
                  </span>
                </span>
              </span>

              <span className="filter-caret" data-open={audienceOpen}>▾</span>
            </div>
            {audienceOpen && (
              <div className="results-audience-filters" >

                <label className="sport-checkbox all">
                  <input
                    type="checkbox"
                    checked={selectedAudiences.length === 0}
                    onChange={() => {
                      const params = new URLSearchParams(searchParams);
                      params.delete("gender");
                      params.delete("intent");

                      navigate({
                        pathname:
                          selectedSports.length === 1
                            ? stateCode && county
                              ? `/state/${stateCode.toLowerCase()}/county/${county.toLowerCase().replace(/\s+/g, "-")}/sport/${selectedSports[0]}`
                              : stateCode
                                ? `/state/${stateCode.toLowerCase()}/sport/${selectedSports[0]}`
                                : `/sport/${selectedSports[0]}`
                            : selectedSports.length === 0
                              ? stateCode && county
                                ? `/state/${stateCode.toLowerCase()}/county/${county.toLowerCase().replace(/\s+/g, "-")}/audience`
                                : stateCode
                                  ? `/state/${stateCode.toLowerCase()}/audience`
                                  : "/sport"
                              : audienceBasePath,
                        search: params.toString(),
                      });
                    }}

                  />
                  All
                </label>
                {allAudiences.map((a) => {
                  const value = a.toLowerCase();
                  return (
                    <label key={value} className="sport-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedAudiences.includes(value)}
                        onChange={() => toggleAudience(value)}
                      />
                      {formatSlugLabel(a)}
                    </label>
                  );
                })}
              </div>
            )}
          </div>


          {/* AGE DROPDOWN */}
          <div className="results-age-dropdown">
            <div
              className={`result-filter-chip dropdown-trigger ${selectedAges.length > 0 ? "active" : ""}`}
              onClick={() => {
                setSportsOpen(false);
                setAudienceOpen(false);
                setProgramOpen(false);
                setAgeOpen((prev) => !prev);
              }}
            >
              <span className="filter-chip-text-wrap">
                <span className="filter-chip-label">Age</span>
                <span className="filter-chip-value-row">
                  <span className="filter-chip-value">
                    {selectedAges.length === 0
                      ? "All"
                      : selectedAges.length === 1
                        ? formatSlugLabel(selectedAges[0])
                        : `${formatSlugLabel(selectedAges[0])} +${selectedAges.length - 1}`}
                  </span>
                </span>
              </span>

              <span className="filter-caret" data-open={ageOpen}>▾</span>
            </div>
            {ageOpen && (
              <div className="results-age-filters">

                {/* ALL */}
                <label className="sport-checkbox all">
                  <input
                    type="checkbox"
                    checked={selectedAges.length === 0}
                    onChange={() => {
                      const params = new URLSearchParams(searchParams);
                      params.delete("age");
                      params.set("intent", "age");
                      setSearchParams(params, { replace: true });
                    }}
                  />
                  All
                </label>

                <div style={{ height: "1px", background: "#eee", margin: "8px 0" }} />

                {/* YOUTH SECTION */}
                {visibleYouthBuckets.length > 0 && (
                  <label className="sport-checkbox">
                    <input
                      type="checkbox"
                      checked={isYouthGroupSelected}
                      onChange={() => toggleAgeGroup("youth")}
                    />
                    Youth (All)
                  </label>
                )}
                {visibleYouthBuckets.map((bucket) => {
                  const value = getYouthBucketValue(bucket);
                  return (
                    <label key={value} className="sport-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedAges.includes(value)}
                        onChange={() => toggleAge(value)}
                      />
                      {bucket.label}
                    </label>
                  );
                })}

                <div style={{ height: "1px", background: "#eee", margin: "8px 0" }} />

                {/* ADULT SECTION */}
                {visibleAdultBuckets.length > 0 && (
                  <label className="sport-checkbox">
                    <input
                      type="checkbox"
                      checked={isAdultGroupSelected}
                      onChange={() => toggleAgeGroup("adult")}
                    />
                    Adult (All)
                  </label>
                )}

                {visibleAdultBuckets.map((bucket) => {
                  const value = getAdultBucketValue(bucket);
                  return (
                    <label key={value} className="sport-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedAges.includes(value)}
                        onChange={() => toggleAge(value)}
                      />
                      {bucket.label}
                    </label>
                  );
                })}

              </div>
            )}
          </div>


          {/* PROGRAM TYPE DROPDOWN */}
          <div className="results-program-dropdown">
            <div
              className={`result-filter-chip dropdown-trigger ${selectedPrograms.length > 0 ? "active" : ""}`}
              onClick={() => {
                setSportsOpen(false);
                setAudienceOpen(false);
                setAgeOpen(false);
                setProgramOpen((prev) => !prev);
              }}
            >
              <span className="filter-chip-text-wrap">
                <span className="filter-chip-label">Program Type</span>
                <span className="filter-chip-value-row">
                  <span className="filter-chip-value">
                    {selectedPrograms.length === 0
                      ? "All"
                      : selectedPrograms.length === 1
                        ? getProgramTypeLabel(selectedPrograms[0])
                        : `${getProgramTypeLabel(selectedPrograms[0])} +${selectedPrograms.length - 1}`}
                  </span>
                </span>
              </span>

              <span className="filter-caret" data-open={programOpen}>▾</span>
            </div>
            {programOpen && (
              <div className="results-program-filters">

                <label className="sport-checkbox all">
                  <input
                    type="checkbox"
                    checked={selectedPrograms.length === 0}
                    onChange={() => {
                      if (selectedPrograms.length === 0) return;

                      const params = new URLSearchParams(searchParams);
                      params.delete("type");
                      params.set("intent", "type");
                      setSearchParams(params, { replace: true });
                    }}
                  />
                  All
                </label>
                {allPrograms.map((a) => {
                  const value = a.toLowerCase();
                  return (
                    <label key={value} className="sport-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedPrograms.includes(value)}
                        onChange={() => toggleProgram(value)}
                      />
                      {getProgramTypeLabel(value)}
                    </label>
                  );
                })}
              </div>
            )}
          </div>
          <div className="results-location-group" ref={locationDropdownRef}>
            <div className="results-state-chip">
              <div
                className={`result-filter-chip dropdown-trigger ${stateCode ? "active" : ""}`}
                onClick={() => {
                  setCountyOpen(false);
                  setStateOpen((prev) => !prev);
                }}
              >
                <span className="filter-chip-text-wrap">
                  <span className="filter-chip-label">State</span>
                  <span className="filter-chip-value-row">
                    <span className="filter-chip-value">
                      {stateCode ? stateLabel : "All"}
                    </span>
                  </span>
                </span>

                <span className="filter-caret" data-open={stateOpen}>▾</span>
              </div>

              {stateOpen && (
                <div className="results-state-filters">
                  <label className="sport-checkbox all">
                    <input
                      type="checkbox"
                      checked={!stateCode}
                      onChange={() => {
                        const preservedSearch = getPreservedSearch();

                        if (selectedSports.length === 1 && selectedAudiences.length === 1) {
                          navigate({
                            pathname: `/sport/${selectedSports[0]}/audience/${selectedAudiences[0]}`,
                            search: preservedSearch,
                          });
                        } else if (selectedSports.length === 1) {
                          navigate({
                            pathname: `/sport/${selectedSports[0]}`,
                            search: preservedSearch,
                          });
                        } else if (selectedAudiences.length === 1) {
                          navigate({
                            pathname: `/audience/${selectedAudiences[0]}`,
                            search: preservedSearch,
                          });
                        } else {
                          navigate({
                            pathname: "/sport",
                            search: preservedSearch,
                          });
                        }

                        setStateOpen(false);
                        setCountyOpen(false);
                      }}
                    />
                    All
                  </label>

                  {availableStates.map((code) => {
                    const match = US_STATES.find(
                      (s) => s.code.toLowerCase() === code.toLowerCase()
                    );

                    if (!match) return null;

                    return (
                      <label key={match.code} className="sport-checkbox">
                        <input
                          type="checkbox"
                          checked={stateCode?.toLowerCase() === match.code.toLowerCase()}
                          onChange={() => selectState(match.code)}
                        />
                        {match.name}
                      </label>
                    );
                  })}
                </div>
              )}
            </div>

            {stateCode && (
              <div className="results-county-chip">
                <div
                  className={`result-filter-chip dropdown-trigger ${county ? "active" : ""}`}
                  onClick={() => {
                    setStateOpen(false);
                    setCountyOpen((prev) => !prev);
                  }}
                >
                  <span className="filter-chip-text-wrap">
                    <span className="filter-chip-label">County</span>
                    <span className="filter-chip-value-row">
                      <span className="filter-chip-value">
                        {county ? countyLabel : "All"}
                      </span>
                    </span>
                  </span>

                  <span className="filter-caret" data-open={countyOpen}>▾</span>
                </div>

                {countyOpen && (
                  <div className="results-county-filters">
                    <label className="sport-checkbox all">
                      <input
                        type="checkbox"
                        checked={!county}
                        onChange={() => {
                          const preservedSearch = getPreservedSearch();
                          const nextState = stateCode.toLowerCase();

                          if (selectedSports.length === 1 && selectedAudiences.length === 1) {
                            navigate({
                              pathname: `/state/${nextState}/sport/${selectedSports[0]}/audience/${selectedAudiences[0]}`,
                              search: preservedSearch,
                            });
                          } else if (selectedSports.length === 1) {
                            navigate({
                              pathname: `/state/${nextState}/sport/${selectedSports[0]}`,
                              search: preservedSearch,
                            });
                          } else if (selectedAudiences.length === 1) {
                            navigate({
                              pathname: `/state/${nextState}/audience/${selectedAudiences[0]}`,
                              search: preservedSearch,
                            });
                          } else {
                            navigate({
                              pathname: `/state/${nextState}/sport`,
                              search: preservedSearch,
                            });
                          }

                          setCountyOpen(false);
                        }}
                      />
                      All
                    </label>

                    {counties
                      .filter((c) => c.county && c.county.trim())
                      .slice()
                      .sort((a, b) => a.county.localeCompare(b.county))
                      .map((c) => (
                        <label key={c.county} className="sport-checkbox">
                          <input
                            type="checkbox"
                            checked={county?.toLowerCase() === c.county.toLowerCase()}
                            onChange={() => selectCounty(c.county)}
                          />
                          {toTitleCase(c.county)}
                        </label>
                      ))}
                  </div>
                )}
              </div>
            )}
          </div>




          {/* {isUS && county && ` in ${toTitleCase(county)}`}
        {isUS && stateName && !county && ` in ${getStateLabel(stateName)}`} */}
          <div className="filters-clear-wrapper">
            {hasActiveFilters && (
              <span className="results-reset" onClick={resetFilters}>
                Clear
              </span>
            )}
          </div>

        </div>

      </div>


      <div className="results-summary-row">
        {/* <div className="results-summary">
          <div>
            <strong>{count} Results</strong>
            {displayText && ` ${displayText}`}
          </div>
        </div> */}



        {/* <div className="results-view-toggle">
          <button
            className={`view-btn ${viewMode === "grid" ? "active" : ""}`}
            onClick={() => setViewMode("grid")}
          >
 
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="7" height="7" rx="1" fill="currentColor" />
              <rect x="14" y="3" width="7" height="7" rx="1" fill="currentColor" />
              <rect x="3" y="14" width="7" height="7" rx="1" fill="currentColor" />
              <rect x="14" y="14" width="7" height="7" rx="1" fill="currentColor" />
            </svg>
          </button>

          <button
            className={`view-btn ${viewMode === "list" ? "active" : ""}`}
            onClick={() => setViewMode("list")}
          >
      
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect x="4" y="5" width="16" height="2" rx="1" fill="currentColor" />
              <rect x="4" y="11" width="16" height="2" rx="1" fill="currentColor" />
              <rect x="4" y="17" width="16" height="2" rx="1" fill="currentColor" />
            </svg>
          </button>
        </div> */}



      </div>
    </div>
  );
}

export default DirectoryResultsFilters;
